import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/laporan/registrasi-nasabah",
    url_path: "/laporan/registrasi-nasabah",
  },
];
